(() => {
  function init(section) {
    const input = section.querySelector('[data-category-live-search]');
    const root = section.querySelector('[data-category-search-root]');
    if (!input || !root || input.dataset.bound) return;
    input.dataset.bound = 'true';
    const grid = root.querySelector('.cjs-category-collection__grid');
    const status = section.querySelector('[data-category-search-status]');
    if (!grid) { input.disabled = false; status.hidden = true; return; }
    const count = root.querySelector('.cjs-category-collection__results-count');
    const originalCount = count.textContent;
    const pagination = root.querySelector('.cjs-category-collection__pagination');
    const originalNodes = [...grid.children];
    const items = new Map();
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const ingest = (nodes, page) => nodes.forEach((node, index) => items.set(node.dataset.categoryProduct, {node, order: page * 1000 + index, text: normalize(node.dataset.searchText || '')}));
    ingest(originalNodes, Number(root.dataset.page));
    const empty = document.createElement('p');
    empty.className = 'cjs-category-collection__empty';
    empty.textContent = root.dataset.empty;
    empty.hidden = true;
    grid.after(empty);
    let ready = false;
    let frame = null;
    let composing = false;
    let displayed = originalNodes;
    input.value = new URL(location.href).searchParams.get('cjs_q') || '';
    function persist() {
      const url = new URL(location.href);
      if (input.value.trim()) url.searchParams.set('cjs_q', input.value.trim());
      else url.searchParams.delete('cjs_q');
      history.replaceState(null, '', url);
      section.querySelectorAll('form').forEach(form => {
        let field = form.querySelector('input[name="cjs_q"]');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'cjs_q'; form.append(field); }
        field.value = input.value.trim();
      });
    }
    function render() {
      frame = null;
      if (!ready || composing) return;
      const terms = normalize(input.value).split(/\s+/).filter(Boolean);
      const matches = terms.length ? [...items.values()].sort((a, b) => a.order - b.order).filter(item => terms.every(term => item.text.includes(term))).map(item => item.node) : originalNodes;
      if (matches.length !== displayed.length || matches.some((node, i) => node !== displayed[i])) {
        grid.replaceChildren(...matches);
        displayed = matches;
      }
      empty.hidden = !terms.length || matches.length > 0;
      if (pagination) pagination.hidden = terms.length > 0;
      count.textContent = terms.length ? String(matches.length) + ' / ' + root.dataset.total : originalCount;
      persist();
    }
    function schedule() { if (ready && !composing && frame === null) frame = requestAnimationFrame(render); }
    input.addEventListener('input', event => { if (!event.isComposing) schedule(); });
    input.addEventListener('search', schedule);
    input.addEventListener('compositionstart', () => { composing = true; });
    input.addEventListener('compositionend', () => { composing = false; schedule(); });
    section.addEventListener('click', event => {
      const link = event.target.closest('.cjs-category-collection__active-chip, .cjs-category-collection__clear-link, .cjs-category-collection__pagination a');
      if (!link || !input.value.trim()) return;
      const url = new URL(link.href); url.searchParams.set('cjs_q', input.value.trim()); link.href = url.href;
    });
    async function load() {
      try {
        const pages = Number(root.dataset.pages);
        const current = Number(root.dataset.page);
        const queue = Array.from({length: pages}, (_, i) => i + 1).filter(page => page !== current);
        await Promise.all(Array.from({length: Math.min(2, queue.length)}, async () => {
          while (queue.length) {
            const page = queue.shift();
            const url = new URL(location.href); url.searchParams.delete('cjs_q'); url.searchParams.set('page', String(page)); url.searchParams.set('section_id', root.dataset.sectionId);
            const response = await fetch(url, {credentials: 'same-origin'});
            if (!response.ok) throw new Error('Collection unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fetched = doc.querySelector('[data-category-search-root]');
            if (!fetched || Number(fetched.dataset.page) !== page) throw new Error('Incomplete collection');
            ingest([...fetched.querySelectorAll('[data-category-product]')], page);
          }
        }));
        if (items.size !== Number(root.dataset.total)) throw new Error('Incomplete collection');
        ready = true; input.disabled = false; status.hidden = true; render();
      } catch {
        status.textContent = status.dataset.error.replace('{loaded}', String(items.size)).replace('{total}', root.dataset.total);
        const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = status.dataset.retry; retry.addEventListener('click', () => location.reload()); status.append(retry);
        status.hidden = false;
      }
    }
    persist(); load();
  }
  function boot() { document.querySelectorAll('[data-cjs-category-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
